import { useContentOverflow } from '../../../../../hooks'
import { Avatar, AVATAR_HEIGHT_24 } from '../../../../Avatar'
import { FloatingTooltip } from '../../../../Floating'
import Text from '../../../../Text'

import * as styles from './RequestBoardCardTitle.module.css'

import ServiceRequestIcon from '../../../../../icons/service-request.svg'

function RequestBoardCardTitle({ title, unread }) {
  const { overflow, setContentOverflowRef } = useContentOverflow({
    dep: [title],
  })

  return (
    <div className={styles.RequestBoardCardTitle}>
      <Avatar
        Icon={ServiceRequestIcon}
        className={styles.avatar}
        size={AVATAR_HEIGHT_24}
      />
      <FloatingTooltip content={title} disabled={!overflow}>
        <Text
          className={styles.title}
          ref={setContentOverflowRef}
          unread={unread}
        >
          {title}
        </Text>
      </FloatingTooltip>
    </div>
  )
}

export default RequestBoardCardTitle
